import AdminDashboardPage from '@/modules/admin/dashboard/admin-dashboard-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/admin/')({
  component: AdminDashboardPage,
});
